// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*DESKTOP*/
@media screen and (min-width:1024px) {
     /*CSS DO RADIO BUTTON*/
     .Fields_radio__E3BrZ {
          display: flex;
     }

     /*CSS DOS INPUTS E SELECT*/
     .Fields_container__8V8IU {
          text-transform: capitalize;
          display: grid;
          grid-template-columns: 20% 80%;
          align-items: center;
     }

     .Fields_containerWithoutLabel__7funD {
          text-transform: capitalize;
          align-items: center;
          display: grid;
     }

     .Fields_label__NNSk8 {
          margin-bottom: 0.5%;
     }

     /*CSS DOS INPUTS*/
     .Fields_input__Aex3m {
          margin-bottom: 1%;
          height: 70%;
          width: 100%;
     }

     .Fields_input__Aex3m:valid{
          background-color: rgb(179, 255, 0);
     }

     /*CSS DOS SELECTS*/
     .Fields_component__mRRjR>p{
          text-align: center;
     }

     .Fields_select__-ZPTV {
          margin-bottom: 1%;
          width: 100%;
     }
}

/*TABLET*/
@media screen and (min-width:767px) and (max-width:1024px) {
     /*CSS DO RADIO BUTTON*/
     .Fields_radio__E3BrZ {
          display: flex;
     }

     /*CSS DOS INPUTS E SELECT*/
     .Fields_container__8V8IU {
          text-transform: capitalize;
          display: grid;
          grid-template-columns: 20% 80%;
          align-items: center;
     }

     .Fields_containerWithoutLabel__7funD {
          text-transform: capitalize;
          align-items: center;
     }

     .Fields_label__NNSk8 {
          /* text-align:right; */
          margin-bottom: 0.5%;
     }

     /*CSS DOS INPUTS*/
     .Fields_input__Aex3m {
          margin-bottom: 1%;
          height: 45px;
          width: 100%;
     }

     /*CSS DOS SELECTS*/
     .Fields_component__mRRjR>p{
          text-align: center;
     }

     .Fields_select__-ZPTV {
          margin-bottom: 1%;
          height: 100%;
          width: 100%;
     }
}

/*MOBILE*/
@media screen and (max-width:767px) {
     /*CSS DO RADIO BUTTON*/
     .Fields_radio__E3BrZ {
          display: flex;
     }

     /*CSS DOS INPUTS E SELECT*/
     .Fields_container__8V8IU {
          text-transform: capitalize;
          display: grid;
          grid-template-columns: 20% 80%;
          align-items: center;
     }

     .Fields_containerWithoutLabel__7funD {
          text-transform: capitalize;
          align-items: center;
     }

     .Fields_label__NNSk8 {
          /* text-align:right; */
          margin-bottom: 0.5%;
     }

     /*CSS DOS INPUTS*/
     .Fields_input__Aex3m {
          margin-bottom: 1%;
          height: 44px;
          width: 100%;
     }

     /*CSS DOS SELECTS*/
     .Fields_component__mRRjR>p{
          text-align: center;
     }

     .Fields_select__-ZPTV {
          margin-bottom: 1%;
          height: 70%;
          width: 100%;
     }
}`, "",{"version":3,"sources":["webpack://./src/components/genericFields/fields/Fields.module.css"],"names":[],"mappings":"AAAA,UAAU;AACV;KACK,sBAAsB;KACtB;UACK,aAAa;KAClB;;KAEA,0BAA0B;KAC1B;UACK,0BAA0B;UAC1B,aAAa;UACb,8BAA8B;UAC9B,mBAAmB;KACxB;;KAEA;UACK,0BAA0B;UAC1B,mBAAmB;UACnB,aAAa;KAClB;;KAEA;UACK,mBAAmB;KACxB;;KAEA,iBAAiB;KACjB;UACK,iBAAiB;UACjB,WAAW;UACX,WAAW;KAChB;;KAEA;UACK,kCAAkC;KACvC;;KAEA,kBAAkB;KAClB;UACK,kBAAkB;KACvB;;KAEA;UACK,iBAAiB;UACjB,WAAW;KAChB;AACL;;AAEA,SAAS;AACT;KACK,sBAAsB;KACtB;UACK,aAAa;KAClB;;KAEA,0BAA0B;KAC1B;UACK,0BAA0B;UAC1B,aAAa;UACb,8BAA8B;UAC9B,mBAAmB;KACxB;;KAEA;UACK,0BAA0B;UAC1B,mBAAmB;KACxB;;KAEA;UACK,sBAAsB;UACtB,mBAAmB;KACxB;;KAEA,iBAAiB;KACjB;UACK,iBAAiB;UACjB,YAAY;UACZ,WAAW;KAChB;;KAEA,kBAAkB;KAClB;UACK,kBAAkB;KACvB;;KAEA;UACK,iBAAiB;UACjB,YAAY;UACZ,WAAW;KAChB;AACL;;AAEA,SAAS;AACT;KACK,sBAAsB;KACtB;UACK,aAAa;KAClB;;KAEA,0BAA0B;KAC1B;UACK,0BAA0B;UAC1B,aAAa;UACb,8BAA8B;UAC9B,mBAAmB;KACxB;;KAEA;UACK,0BAA0B;UAC1B,mBAAmB;KACxB;;KAEA;UACK,sBAAsB;UACtB,mBAAmB;KACxB;;KAEA,iBAAiB;KACjB;UACK,iBAAiB;UACjB,YAAY;UACZ,WAAW;KAChB;;KAEA,kBAAkB;KAClB;UACK,kBAAkB;KACvB;;KAEA;UACK,iBAAiB;UACjB,WAAW;UACX,WAAW;KAChB;AACL","sourcesContent":["/*DESKTOP*/\n@media screen and (min-width:1024px) {\n     /*CSS DO RADIO BUTTON*/\n     .radio {\n          display: flex;\n     }\n\n     /*CSS DOS INPUTS E SELECT*/\n     .container {\n          text-transform: capitalize;\n          display: grid;\n          grid-template-columns: 20% 80%;\n          align-items: center;\n     }\n\n     .containerWithoutLabel {\n          text-transform: capitalize;\n          align-items: center;\n          display: grid;\n     }\n\n     .label {\n          margin-bottom: 0.5%;\n     }\n\n     /*CSS DOS INPUTS*/\n     .input {\n          margin-bottom: 1%;\n          height: 70%;\n          width: 100%;\n     }\n\n     .input:valid{\n          background-color: rgb(179, 255, 0);\n     }\n\n     /*CSS DOS SELECTS*/\n     .component>p{\n          text-align: center;\n     }\n\n     .select {\n          margin-bottom: 1%;\n          width: 100%;\n     }\n}\n\n/*TABLET*/\n@media screen and (min-width:767px) and (max-width:1024px) {\n     /*CSS DO RADIO BUTTON*/\n     .radio {\n          display: flex;\n     }\n\n     /*CSS DOS INPUTS E SELECT*/\n     .container {\n          text-transform: capitalize;\n          display: grid;\n          grid-template-columns: 20% 80%;\n          align-items: center;\n     }\n\n     .containerWithoutLabel {\n          text-transform: capitalize;\n          align-items: center;\n     }\n\n     .label {\n          /* text-align:right; */\n          margin-bottom: 0.5%;\n     }\n\n     /*CSS DOS INPUTS*/\n     .input {\n          margin-bottom: 1%;\n          height: 45px;\n          width: 100%;\n     }\n\n     /*CSS DOS SELECTS*/\n     .component>p{\n          text-align: center;\n     }\n\n     .select {\n          margin-bottom: 1%;\n          height: 100%;\n          width: 100%;\n     }\n}\n\n/*MOBILE*/\n@media screen and (max-width:767px) {\n     /*CSS DO RADIO BUTTON*/\n     .radio {\n          display: flex;\n     }\n\n     /*CSS DOS INPUTS E SELECT*/\n     .container {\n          text-transform: capitalize;\n          display: grid;\n          grid-template-columns: 20% 80%;\n          align-items: center;\n     }\n\n     .containerWithoutLabel {\n          text-transform: capitalize;\n          align-items: center;\n     }\n\n     .label {\n          /* text-align:right; */\n          margin-bottom: 0.5%;\n     }\n\n     /*CSS DOS INPUTS*/\n     .input {\n          margin-bottom: 1%;\n          height: 44px;\n          width: 100%;\n     }\n\n     /*CSS DOS SELECTS*/\n     .component>p{\n          text-align: center;\n     }\n\n     .select {\n          margin-bottom: 1%;\n          height: 70%;\n          width: 100%;\n     }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radio": `Fields_radio__E3BrZ`,
	"container": `Fields_container__8V8IU`,
	"containerWithoutLabel": `Fields_containerWithoutLabel__7funD`,
	"label": `Fields_label__NNSk8`,
	"input": `Fields_input__Aex3m`,
	"component": `Fields_component__mRRjR`,
	"select": `Fields_select__-ZPTV`
};
export default ___CSS_LOADER_EXPORT___;
